import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../../environments/environment';

@Component({
    selector: 'app-vitrine-menu',
    templateUrl: './vitrine-menu.component.html',
    styleUrls: ['./vitrine-menu.component.css'],
    standalone: false
})
export class VitrineMenuComponent implements OnInit {
  environment = environment;
  constructor() { }

  ngOnInit() {
  }

}
